import { Helmet } from "react-helmet-async";
import { useTenant } from "../../context/TenantContext";

export default function SEO({ title, description, image, url }) {
  const { tenant } = useTenant();

  const pageTitle = title || tenant?.MetaTitle || tenant?.BusinessName;

  const pageDescription =
    description || tenant?.MetaDescription || tenant?.BusinessDescription;

  const pageImage = image || tenant?.LogoUrl;

  const pageUrl = url || window.location.href;

  return (
    <Helmet>
      <title>{pageTitle}</title>

      <meta name="description" content={pageDescription} />

      <meta name="keywords" content={tenant?.MetaKeywords} />

      <meta property="og:title" content={pageTitle} />

      <meta property="og:description" content={pageDescription} />

      <meta property="og:image" content={pageImage} />

      <meta property="og:url" content={pageUrl} />

      <meta property="og:site_name" content={tenant?.BusinessName} />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: tenant?.BusinessName,
          url: window.location.origin,
        })}
      </script>
    </Helmet>
  );
}
